import { MappingProblemSolutionStatus } from '@/constants';
import { AbstractModel } from '@/models/abstractModel';
import type { IMappingProblemSolutionRaw } from '@/types/mappingProblem';

export class MappingProblemSolutionItem extends AbstractModel {
    public appliedAt: string | null;
    public createdAt: string;
    public description: string;
    public id: number;
    public mappingProblemId: number;
    public statusId: MappingProblemSolutionStatus;
    public updatedAt: string;
    public variantNo: number;

    constructor(raw: IMappingProblemSolutionRaw) {
        super();
        this.id = raw.id;
        this.mappingProblemId = raw.mapping_problem_id;
        this.description = raw.description;
        this.variantNo = raw.variant_no;
        this.statusId = raw.status_id;
        this.createdAt = raw.created_at;
        this.updatedAt = raw.updated_at;
        this.appliedAt = raw.applied_at;
    }
}
